/**
 * ExternalUser entity class
 */

/**
 * ExternalUserFactory
 * returns ExternalUser entity class
 *
 * @class ExternalUserFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ExternalUser} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ExternalUserFactory
 */
/* @ngInject */
export default function ExternalUserFactory (Entity, Type, onOffMixin) {
  /* === ExternalUser class === */

  /**
   * ExternalUser model
   *
   * @class ExternalUser
   * @classdesc ExternalUser model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing ExternalUser entity fields
   * @return {models.ExternalUser} ExternalUser entity
   */
  function ExternalUser () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ExternalUser.prototype = Object.create(Entity.prototype)
  ExternalUser.prototype.constructor = ExternalUser

  /* === ExternalUser instance methods & fields === */

  Object.assign(ExternalUser.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ExternalUser#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      addOns: ['Subscription'],
      enabled: Boolean,
      login: String,
      network: Type.Stump('ExternalUserExtraNetwork', ['id', 'name']),
      subscriptions: ['Subscription'],
      token: String
    },

    /**
     * url template
     *
     * @memberof models.ExternalUser#
     * @type {String}
     */
    _urlTemplate: 'api/extusers/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.ExternalUser#
     * @type {String}
     */
    _publicUrlTemplate: 'extusers/{{::id}}'

  }, onOffMixin)

  /* === ExternalUser static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(ExternalUser, Entity)
  ExternalUser._name = 'ExternalUser'
  ExternalUser.init()

  // permissions
  ExternalUser.access = {
    view: 'viewAPIAccessGlobal',
    create: 'createAPIAccessGlobal',
    edit: 'editAPIAccessGlobal',
    delete: 'deleteAPIAccessGlobal'
  }

  // extra
  ExternalUser.extra = {
    networks: ['ExternalUserExtraNetwork']
  }

  return ExternalUser
}
